// src/components/modals/ConfirmDialog.jsx
// Phase 4 step 14a-3: the danger button now uses the button kit's `danger` variant (logged in 13b).
import React from 'react';
import { AlertTriangle, Info, Trash2, X } from 'lucide-react';
import { Button } from '@/components/ui/button.jsx';

export default function ConfirmDialog({ 
  isOpen, 
  onClose, 
  onConfirm,
  title = 'Confirm Action',
  message = 'Are you sure you want to proceed?',
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  variant = 'danger' // 'danger' | 'warning' | 'info'
}) {
  
  if (!isOpen) return null;

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  // Icon and color based on variant
  const variantConfig = {
    danger: {
      icon: Trash2,
      iconColor: 'text-red-500',
      iconBg: 'bg-red-500/10',
      buttonVariant: 'danger'      // was 'destructive', which ui/button.jsx does not define (the button had no background)
    },
    warning: {
      icon: AlertTriangle,
      iconColor: 'text-amber-500',
      iconBg: 'bg-amber-500/10',
      buttonVariant: 'default'
    },
    info: {
      icon: Info,
      iconColor: 'text-blue-500',
      iconBg: 'bg-blue-500/10',
      buttonVariant: 'default'
    }
  };

  const config = variantConfig[variant] || variantConfig.danger;
  const Icon = config.icon;

  return (
    <>
      {/* Backdrop */}
      <div 
        className="fixed inset-0 bg-black/50 z-50 backdrop-blur-sm"
        onClick={onClose}
      />

      {/* Dialog */}
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
        <div 
          className="bg-[#1a1a1a] border border-[#2a2a2a] rounded-xl shadow-2xl max-w-md w-full"
          onClick={(e) => e.stopPropagation()}
        >
          {/* Content */}
          <div className="p-6">
            {/* Icon */}
            <div className={`w-12 h-12 rounded-full ${config.iconBg} flex items-center justify-center mb-4`}>
              <Icon className={`w-6 h-6 ${config.iconColor}`} />
            </div>

            {/* Title */}
            <h2 className="text-xl font-semibold text-white mb-2">
              {title}
            </h2>

            {/* Message */}
            <p className="text-sm text-[#a0a0a0] mb-6">
              {message}
            </p>

            {/* Actions */}
            <div className="flex items-center justify-end gap-3">
              <Button variant="secondary" onClick={onClose}>
                {cancelText}
              </Button>
              <Button variant={config.buttonVariant} onClick={handleConfirm}>
                {confirmText}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}